import React, { useState, useEffect } from "react";

// Formik Validation
import * as Yup from "yup";
import { useFormik as useFormic } from "formik";

import { AppDispatch, RootState } from "../../../slices/store";
import { useAppDispatch, useAppSelector } from "../../../slices/hook";
import { editProfile } from "../../../slices/thunk";

import userProfile from "assets/images/users/user-profile.png";
import BreadCrumb from "../../../common/breadcrumb";
import withRouter from "../../../common/with-router";

import ChangePasswordComponent from "./change-password-component";

import { BrandingData } from "../../settings/branding";
import { getAuthState } from "../../../slices/auth/login/reducer";

const AdminUserProfile = () => {
  //meta title
  document.title = "Profile" + BrandingData.titleSuffix;

  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser, error, success } = useAppSelector(getAuthState);

  const validation = useFormic({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: loggedInuser?.username ?? "",
      idx: loggedInuser?.id ?? "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      //dispatch(editProfile(values));
    },
  });

  return (
    <React.Fragment>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        {/* Render Breadcrumb */}
        <BreadCrumb title={BrandingData.siteName} pageTitle="Profile" />

        <div className="row">
          <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-1">
            {success && (
              <div
                className="px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                id="successAlert"
              >
                You have <b>successfully</b> update profile.
              </div>
            )}
            {error && (
              <div
                className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
                id="successAlert"
              >
                You have <b>failed</b> to update profile.
              </div>
            )}

            <div className="card">
              <div className="card-body">
                <div className="flex gap-3">
                  <div>
                    <img src={userProfile} alt="" className="avatar-md rounded-circle img-thumbnail" />
                  </div>
                  <div className="text-slate-500 dark:text-zink-200">
                    <h5 className="text-slate-500">{loggedInuser?.username ?? ""}</h5>
                    <p className="mb-1">{loggedInuser?.email ?? ""}</p>
                    <p className="mb-1">{loggedInuser?.activeRole?.name ?? ""}</p>
                    <p className="mb-0">Ref: #{loggedInuser?.id ?? ""}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loggedInuser && <ChangePasswordComponent user={loggedInuser}></ChangePasswordComponent>}
      </div>
    </React.Fragment>
  );
};

export default withRouter(AdminUserProfile);
